import CantileverButton, { EditButton } from 'components/CantileverButton'
import CantileverCard from 'components/CantileverCard'
import React from 'react'
import { styled } from 'styled-components'

export const CancelAndSaveContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  button {
    flex-basis: 0;
    flex-grow: 1;
    flex-shrink: 0;
    padding: 0 0.75rem;
  }
`
export interface FormHeaderProps {
  saveCancelButtons: boolean
  inCreateMode?: boolean
  formRef?: React.RefObject<HTMLFormElement | null>
  handleSave: (formRef?: React.RefObject<HTMLFormElement | null>) => void
  handleEdit: (formId: string) => void
  handleCancel: (formId: string) => void
  handleAdd?: () => void
  handleNonFormSave?: () => void
  formID: string
}
export const EditSaveCancelButtons: React.FC<FormHeaderProps> = ({
  saveCancelButtons,
  inCreateMode = false,
  formRef,
  handleSave,
  handleEdit,
  handleCancel,
  handleAdd,
  handleNonFormSave,
  formID,
}) => {
  return (
    <>
      {inCreateMode ? (
        <CancelAndSaveContainer>
          <CantileverButton primary onClick={() => handleSave(formRef)}>
            Create
          </CantileverButton>
        </CancelAndSaveContainer>
      ) : saveCancelButtons ? (
        <CancelAndSaveContainer>
          {handleAdd && (
            <CantileverButton onClick={handleAdd}>Add</CantileverButton>
          )}
          <CantileverButton onClick={() => handleCancel(formID)}>
            Cancel
          </CantileverButton>
          <CantileverButton
            primary
            onClick={() =>
              handleNonFormSave ? handleNonFormSave() : handleSave(formRef)
            }>
            Save
          </CantileverButton>
        </CancelAndSaveContainer>
      ) : (
        <CantileverCard.HiddenUnlessHovering>
          <EditButton ghost onClick={() => handleEdit(formID)} />
        </CantileverCard.HiddenUnlessHovering>
      )}
    </>
  )
}
